import React from "react";
import { FieldValues, OnSubmit } from "react-hook-form";
import Button from "../../../../Components/FormElements/Button";
import FirstCardRecalculateModality from "./RecalculateModalityCardChildren/firstCard";
import SecondCardRecalculateModality from "./RecalculateModalityCardChildren/secondCard";
import ThirdCardRecalculateModality from "./RecalculateModalityCardChildren/thirdCard";
import FormRecalculateModality from "./RecalculateModalityCardChildren/formRecalculate";
import { DualRing } from "react-loading-io";
import { useExchangeRate } from "../../../../customHook/useExchangeRate";

interface RecalculateModalityCardProps {
  selectedModality: any;
  data: any;
  dataRecalculate: any;
  typeMoneyDescriptionList: any;
  conditionInvalidateList: any;
  errorDate: any;
  selectDate1: any;
  setValue: any;
  register: any;
  errors: any;
  showWarning: boolean;
  handleSubmit: (
    callback: OnSubmit<FieldValues>
  ) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  onSubmitReCalculate: (values: any) => Promise<void>;
  handleDateChange: (initDate: any, typeDate: any) => void;
  saveRecalculated: (exchangeRate: number | null) => Promise<void>;
  validateInitialValue: (monto: any, initialValue: any) => void;
}

const RecalculateModalityCard = ({
  selectedModality,
  data,
  dataRecalculate,
  typeMoneyDescriptionList,
  conditionInvalidateList,
  errorDate,
  selectDate1,
  setValue,
  register,
  errors,
  showWarning,
  handleSubmit,
  onSubmitReCalculate,
  handleDateChange,
  saveRecalculated,
  validateInitialValue,
}: RecalculateModalityCardProps) => {
  const modalityData =
    selectedModality.respuestaMacro || selectedModality.resultadoEESS || {};
  const hasModalityData =
    selectedModality.respuestaMacro || selectedModality.resultadoEESS;

  const { exchangeRate, loading: isLoadingExchangeRate } = useExchangeRate();

  return (
    <>
      {isLoadingExchangeRate ? (
        <div className="modal-aside__loader">
          <DualRing size={50} />
        </div>
      ) : (
        <>
          {/* primera card */}
          <FirstCardRecalculateModality
            data={data}
            selectedModality={selectedModality}
            typeMoneyDescriptionList={typeMoneyDescriptionList}
            conditionInvalidateList={conditionInvalidateList}
          />
          {/* segunda card */}
          <SecondCardRecalculateModality
            data={data}
            modalityData={modalityData}
            selectedModality={selectedModality}
            hasModalityData={hasModalityData}
          />
          {/* tercera card */}
          <ThirdCardRecalculateModality
            data={data}
            modalityData={modalityData}
            selectedModality={selectedModality}
            hasModalityData={hasModalityData}
          />
          {/* form */}
          <FormRecalculateModality
            data={data}
            dataRecalculate={dataRecalculate}
            errorDate={errorDate}
            selectDate1={selectDate1}
            setValue={setValue}
            register={register}
            errors={errors}
            showWarning={showWarning}
            handleSubmit={handleSubmit}
            onSubmitReCalculate={onSubmitReCalculate}
            handleDateChange={handleDateChange}
            validateInitialValue={validateInitialValue}
            hasModalityData={hasModalityData}
            modalityData={modalityData}
            exchangeRate={exchangeRate}
          />
          {/* seccion buttons */}
          <div className="actions">
            <Button
              disabled={!dataRecalculate}
              onClick={() => saveRecalculated(exchangeRate)}
              className="actions__continue"
            >
              Guardar
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default RecalculateModalityCard;
